import React from 'react'
import { json } from 'react-router-dom';

let walletAm= 0;
let walletCount= 0;
const Order_table = ({ordersList}) => {
     

    const orders =ordersList;
    let data = { orders : 0 , amount : 0 , sold : 0 }
    const fetchRestIDs = () =>{
        ordersList.forEach(order => {
             data.orders =  data.orders + 1 ;
             data.amount = parseFloat(data.amount) + parseFloat(order.total);
             data.sold =  parseInt(data.sold) + parseInt(order.totalQnty);
            // console.log(order.dbID , order.razorPayPaymentId )
            if(order.razorPayPaymentId == ""){
                walletAm +=   parseFloat(order.total);
                walletCount += 1;
            }
        })
        let ids = [];
        orders.map(order => {
            ids.push(order.restaurantId);
        })
        const uniqueList = [...new Set(ids)];
        const countMap = new Map();
          ids.forEach((element) => {
            if (countMap.has(element)) {
                countMap.set(element, countMap.get(element) + 1);
            } else {
                countMap.set(element, 1);
            }
            }); 
            // 23128
            console.log(countMap );
            console.log( "overall " , data  , "wallet" , walletAm , "walletcount" , walletCount);

        return uniqueList;
    }

    
    console.log(fetchRestIDs());

    const getRepeatedIds = () => {
        // Create a Set to store unique razorPayPaymentId values
        const uniquePaymentIds = new Set();
        const repeatedPaymentIds = new Set();
    
        // Iterate over the ordersList to find repeated razorPayPaymentId values
        ordersList.forEach(order => {
            const { razorPayPaymentId } = order;
            if (uniquePaymentIds.has(razorPayPaymentId)) {
                // If the ID is already in the Set, it's a repeat
                repeatedPaymentIds.add(razorPayPaymentId);
            } else {
                // If the ID is not in the Set, add it
                uniquePaymentIds.add(razorPayPaymentId);
            }
        });
    
        // Convert the Set of repeated IDs to an array
        const repeatedIdsArray = Array.from(repeatedPaymentIds);
    
        // Log the repeated IDs for now, you can return or use them as needed
        console.log("Repeated razorPayPaymentId values:", repeatedIdsArray);
    
        // Return the array of repeated IDs if needed
        return repeatedIdsArray;
    }

    console.log(getRepeatedIds() , "repeated payments ...>")

  return (
    
        orders.map(order => {
            const { razorPayPaymentId , orderReview ,orderOTP, restaurantOwner , orderType, restOwnerNo , food , status , total   , year,  customerNo  , orderPickUpItems , orderId    , restaurantId , timeLine,  orderPlatform ,  date ,  time } = order;
            return <tr key={razorPayPaymentId}>
                    <td>{razorPayPaymentId}</td>
                    <td>{orderType}</td>
                    <td>{orderId}</td>
                    <td>{orderPickUpItems}</td> 
                    <td>{time}</td> 
                    <td>{orderReview}</td>
                    <td>{orderOTP}</td>
                    <td>{total}</td>
                    <td>{date}</td>
                    <td>{restaurantId}</td> 
                     <td>{time}</td> 
                    <td>{customerNo}</td> 
                    <td>{status}</td>
                    <td>{orderType}</td> 
                    <td>{orderPlatform}</td> 
                    <td>{restaurantOwner}</td>
                    <td>{restOwnerNo}</td>
                  
                    <td>{JSON.stringify(food).toString()}</td> 
                    <td>{timeLine}</td> 
                    <td>{year}</td> 
                    <td>{customerNo}</td> 
               </tr>
        })
    
  )
}

export default Order_table